import type { Client } from '@src/clients/domain/Client';
import { useNavigateBack } from '@src/common/hooks/useNavigateBack';
import { useToast } from '@src/common/hooks/useToast';
import { ClientsNavigation } from '@src/routing/ClientsNavigation';
import { useCreateTrailer } from '@src/trailer/hooks/useCreateTrailer';
import { TrailerPageContent } from '@src/trailer/TrailerPageContent';
import { useTranslation } from 'react-i18next';

type Props = {
  client: Client;
};

export const AddTrailerPage = ({ client }: Props) => {
  const { t } = useTranslation();
  const { goBack } = useNavigateBack({
    defaultPath: ClientsNavigation.get.url(client.id, 4),
  });

  const { showSuccessToast, showErrorToast } = useToast();

  const { createTrailer, isLoading } = useCreateTrailer({
    clientId: client.id,
    onSuccess: () => {
      showSuccessToast(t('addTrailerSuccess'));
      goBack();
    },
    onError: () => {
      showErrorToast(t('addTrailerError'));
    },
  });

  return (
    <TrailerPageContent
      client={client}
      onSubmit={createTrailer}
      onCancel={goBack}
      onBack={goBack}
      isLoading={isLoading}
    />
  );
};
